// Tile counts per SETTINGS_SECTIONS entry, in page order. Kept as a literal so the router's
// Suspense fallback does not have to import the icon-heavy section config just to size its
// skeleton. hub-skeleton-sections.test.ts keeps this in sync with the derived value.
export const HUB_SKELETON_SECTIONS = [4, 9, 3, 6] as const
